module.exports = __webpack_public_path__ + "../resources/img/ic-navigation-north.614ef39f.svg";